import { useField } from "formik";

import { AIMessageGenerator } from "./AIMessageGenerator";
import { AIMessageGeneratorFormikFieldProps } from "./types";

export function AIMessageGeneratorFormikField({
  name,
  testID = "email-list-area-field",
  label,
  isRequired,
  description,
}: AIMessageGeneratorFormikFieldProps) {
  const [field, meta, helpers] = useField(name);

  return (
    <AIMessageGenerator
      name={name}
      label={label}
      errors={meta.touched ? meta.error : undefined}
      value={field.value}
      isInvalid={Boolean(meta.touched && meta.error)}
      testID={testID}
      isRequired={isRequired}
      onChange={helpers.setValue}
      description={description}
    />
  );
}
